<div class="budget-calculation-container">
  <div class="budget-header">
    <h3 class="mb-3 mt-5">
      {{ "BUDGET_DETAILS_FOR" | globalTranslate }} {{ memberName }}
    </h3>
    <p
      class="text-muted"
      [innerHTML]="getSubheaderText() | globalTranslate"
    ></p>
  </div>
  <!-- Income Budget Calculation Section -->
  @if (incomeItems.length > 0) {
  <div>
    <mat-expansion-panel
      class="budget-section-panel"
      [(expanded)]="incomePanelExpanded"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          "INCOME_BUDGET_CALCULATION" | globalTranslate
        }}</mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="budget-items-list"
        role="list"
        [attr.aria-label]="'INCOME_BUDGET_CALCULATION' | globalTranslate"
      >
        @for (item of incomeItems; track item) {
        <div
          class="budget-item"
          role="listitem"
          [class.total-row]="item.isTotal"
          [class.result-row]="item.isResult"
        >
          <div
            class="budget-item-row"
            [class.hide-on-mobile-when-expanded]="isExpanded(item.id)"
          >
            <!-- Expand Icon -->
            @if (item.isExpandable) {
            <span
              class="expand-icon"
              (click)="toggleItem(item.id)"
              (keydown.enter)="toggleItem(item.id)"
              (keydown.space)="$event.preventDefault(); toggleItem(item.id)"
              tabindex="0"
              role="button"
              [attr.aria-expanded]="isExpanded(item.id)"
              [attr.aria-label]="item?.label | globalTranslate"
            >
              @if (!isExpanded(item.id)) {
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M10 6 L10 14 M6 10 L14 10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              } @if (isExpanded(item.id)) {
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M6 10 L14 10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              }
            </span>
            }
            <div class="budget-label">
              @if (item?.isLink) {
              <span
                class="link-label"
                role="link"
                tabindex="0"
                [attr.aria-label]="
                  'View details for ' + (item.label | globalTranslate)
                "
                (click)="loadSubscreen(item)"
                (keydown.enter)="loadSubscreen(item)"
                (keydown.space)="$event.preventDefault(); loadSubscreen(item)"
              >
                {{ item.label | globalTranslate }}
              </span>
              } @else {
              <span>{{ item?.label | globalTranslate }}</span>
              } @if (item?.hasInfo) {
              <nh-popover
                [content]="getInfoTooltip(item) | globalTranslate"
                class="info-icon-inline"
              ></nh-popover>
              }
            </div>
            <div class="budget-value">
              @if (item?.operator) {
              <span class="operator-sign">{{ item?.operator }}</span>
              } @if (!item.operator && item?.isCurrency !== false) {
              <span class="equals-sign">=</span>
              } @if (item?.isCurrency !== false) {
              <span class="dollar-sign">$</span>
              } @if (item?.isCurrency === false) {
              <span
                class="dollar-sign"
                style="visibility: hidden"
                aria-hidden="true"
                >$</span
              >
              }
              <span
                class="amount-value"
                >{{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}</span
              >
            </div>
          </div>
          <!-- Table Data (when expanded) -->
          @if (isExpanded(item.id)) {
          <div class="detail-table-container" [@expandCollapse]>
            <!-- Desktop Table View -->
            <div
              class="budget-detail-table-wrapper d-none d-md-block"
              tabindex="0"
              role="region"
              [attr.aria-label]="
                (item.label | globalTranslate) + ' scrollable table ' + item.id
              "
            >
              <table
                class="budget-detail-table"
                role="table"
                [attr.aria-label]="
                  (item.label | globalTranslate) + ' details table'
                "
              >
                <thead role="rowgroup">
                  <tr role="row">
                    <th scope="col" role="columnheader">
                      {{ "PERSON" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "TYPE" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "AMOUNT" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "EXCLUDED_AMOUNT" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                    </th>
                  </tr>
                </thead>
                <tbody
                  [@fadeInStagger]="item.tableData?.length || 0"
                  role="rowgroup"
                >
                  @for (row of item.tableData; track row) {
                  <tr role="row">
                    <td role="cell">
                      <div class="person-cell">
                        <div class="person-name">{{ row.person }}</div>
                        @if (row.personId) {
                        <div class="person-meta">{{ row.personId }}</div>
                        }
                      </div>
                    </td>
                    <td role="cell">{{ row.type }}</td>
                    <td class="currency" role="cell">
                      ${{ row.amount | number: "1.2-2" }}
                    </td>
                    <td class="currency" role="cell">
                      ${{ row.excludedAmount | number: "1.2-2" }}
                    </td>
                    <td class="currency" role="cell">
                      ${{ row.countableAmount | number: "1.2-2" }}
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            <!-- Mobile Card View -->
            <div
              class="mobile-card-container d-md-none"
              role="list"
              [attr.aria-label]="
                (item.label | globalTranslate) + ' details list'
              "
            >
              <div class="mobile-card-wrapper">
                <span
                  class="mobile-card-icon mobile_icon"
                  (click)="toggleItem(item.id)"
                  (keydown.enter)="toggleItem(item.id)"
                  (keydown.space)="$event.preventDefault(); toggleItem(item.id)"
                  tabindex="0"
                  role="button"
                  [attr.aria-expanded]="isExpanded(item.id)"
                  [attr.aria-label]="item.label | globalTranslate"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="9"
                      stroke="currentColor"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M6 10 L14 10"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
                <div class="mobile-card">
                  <div class="mobile-card-header">
                    <div class="mobile-card-title">
                      <span>{{ item.label | globalTranslate }}</span>
                      @if (item.hasInfo) {
                      <nh-popover
                        [iconMode]="'transparent'"
                        [content]="getInfoTooltip(item) | globalTranslate"
                        class="mobile-info-icon"
                      ></nh-popover>
                      }
                    </div>
                    <div class="mobile-card-amount">
                      <span class="dollar-sign-table" style="color: #ffffff"
                        >$</span
                      >
                      <span
                        >{{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}</span
                      >
                    </div>
                  </div>
                  <div class="mobile-card-body">
                    @for (row of item.tableData; track row; let isLast = $last)
                    {
                    <ng-container role="listitem">
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "PERSON" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">
                          <div>
                            {{ row.person }}&nbsp;@if (row.personId) {
                            <span class="person-meta">{{ row.personId }}</span>
                            }
                          </div>
                        </span>
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "TYPE" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">{{ row.type }}</span>
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "AMOUNT" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value"
                          >${{ row.amount | number: "1.2-2" }}</span
                        >
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "EXCLUDED_AMOUNT" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value"
                          >${{ row.excludedAmount | number: "1.2-2" }}</span
                        >
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "COUNTABLE_AMOUNT" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value"
                          >${{ row.countableAmount | number: "1.2-2" }}</span
                        >
                      </div>
                      @if (!isLast) {
                      <hr class="mobile-card-divider" />
                      }
                    </ng-container>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
      <!-- SSI/FBR Income Test Section (ABD only) -->
      @if (ssiFbrItems.length > 0) {
      <div>
        <mat-expansion-panel
          class="budget-section-panel"
          [disabled]="true"
          [(expanded)]="ssiFbrPanelExpanded"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "SSI_FBR_INCOME_TEST" | globalTranslate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div
            class="budget-items-list"
            role="list"
            [attr.aria-label]="'SSI_FBR_INCOME_TEST' | globalTranslate"
          >
            @for (item of ssiFbrItems; track item) {
            <div
              class="budget-item"
              role="listitem"
              [class.total-row]="item.isTotal"
              [class.result-row]="item.isResult"
            >
              <div
                class="budget-item-row"
                [class.hide-on-mobile-when-expanded]="isExpanded(item.id)"
              >
                <!-- Expand Icon -->
                @if (item.isExpandable) {
                <span
                  class="expand-icon"
                  (click)="toggleItem(item.id)"
                  (keydown.enter)="toggleItem(item.id)"
                  (keydown.space)="$event.preventDefault(); toggleItem(item.id)"
                  tabindex="0"
                  role="button"
                  [attr.aria-expanded]="isExpanded(item.id)"
                  [attr.aria-label]="item.label | globalTranslate"
                >
                  @if (!isExpanded(item.id)) {
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="9"
                      stroke="currentColor"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M10 6 L10 14 M6 10 L14 10"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  } @if (isExpanded(item.id)) {
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="9"
                      stroke="currentColor"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M6 10 L14 10"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  }
                </span>
                }
                <div class="budget-label">
                  @if (item?.isLink) {
                  <span
                    class="link-label"
                    role="link"
                    tabindex="0"
                    [attr.aria-label]="
                      'View details for ' + (item.label | globalTranslate)
                    "
                    (click)="loadSubscreen(item)"
                    (keydown.enter)="loadSubscreen(item)"
                    (keydown.space)="
                      $event.preventDefault(); loadSubscreen(item)
                    "
                  >
                    {{ item.label | globalTranslate }}
                  </span>
                  } @else {
                  <span>{{ item.label | globalTranslate }}</span>
                  } @if (item?.hasInfo) {
                  <nh-popover
                    [content]="getInfoTooltip(item) | globalTranslate"
                    class="info-icon-inline"
                  ></nh-popover>
                  }
                </div>
                <div class="budget-value">
                  @if (item?.operator) {
                  <span class="operator-sign">{{ item?.operator }}</span>
                  } @if (!item.operator && item?.isCurrency !== false) {
                  <span class="equals-sign">=</span>
                  } @if (item?.isCurrency !== false) {
                  <span class="dollar-sign">$</span>
                  } @if (item?.isCurrency === false) {
                  <span
                    class="dollar-sign"
                    style="visibility: hidden"
                    aria-hidden="true"
                    >$</span
                  >
                  }
                  <span
                    class="amount-value"
                    >{{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}</span
                  >
                </div>
              </div>
              <!-- Table Data (when expanded) - reuse same table structure as income items -->
              @if (isExpanded(item.id)) {
              <div class="detail-table-container" [@expandCollapse]>
                <!-- Desktop Table View -->
                <div
                  class="budget-detail-table-wrapper d-none d-md-block"
                  tabindex="0"
                  role="region"
                  [attr.aria-label]="
                    (item.label | globalTranslate) +
                    ' scrollable table ' +
                    item.id
                  "
                >
                  <table
                    class="budget-detail-table"
                    role="table"
                    [attr.aria-label]="
                      (item.label | globalTranslate) + ' details table'
                    "
                  >
                    <thead role="rowgroup">
                      <tr role="row">
                        <th scope="col" role="columnheader">
                          {{ "PERSON" | globalTranslate }}
                        </th>
                        <th scope="col" role="columnheader">
                          {{ "TYPE" | globalTranslate }}
                        </th>
                        <th scope="col" role="columnheader">
                          {{ "AMOUNT" | globalTranslate }}
                        </th>
                        <th scope="col" role="columnheader">
                          {{ "EXCLUDED_AMOUNT" | globalTranslate }}
                        </th>
                        <th scope="col" role="columnheader">
                          {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      [@fadeInStagger]="item.tableData?.length || 0"
                      role="rowgroup"
                    >
                      @for (row of item.tableData; track row) {
                      <tr role="row">
                        <td role="cell">
                          <div class="person-cell">
                            <div class="person-name">{{ row.person }}</div>
                          </div>
                        </td>
                        <td role="cell">{{ row.type }}</td>
                        <td class="currency" role="cell">
                          ${{ row.amount | number: "1.2-2" }}
                        </td>
                        <td class="currency" role="cell">
                          ${{ row.excludedAmount | number: "1.2-2" }}
                        </td>
                        <td class="currency" role="cell">
                          ${{ row.countableAmount | number: "1.2-2" }}
                        </td>
                      </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <!-- Mobile Card View -->
                <div
                  class="mobile-card-container d-md-none"
                  role="list"
                  [attr.aria-label]="
                    (item.label | globalTranslate) + ' details list'
                  "
                >
                  <div class="mobile-card-wrapper">
                    <span
                      class="mobile-card-icon mobile_icon"
                      (click)="toggleItem(item.id)"
                      (keydown.enter)="toggleItem(item.id)"
                      (keydown.space)="
                        $event.preventDefault(); toggleItem(item.id)
                      "
                      tabindex="0"
                      role="button"
                      [attr.aria-expanded]="isExpanded(item.id)"
                      [attr.aria-label]="item.label | globalTranslate"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="9"
                          stroke="currentColor"
                          stroke-width="1.5"
                          fill="none"
                        />
                        <path
                          d="M6 10 L14 10"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                    <div class="mobile-card">
                      <div class="mobile-card-header">
                        <div class="mobile-card-title">
                          <span>{{ item.label | globalTranslate }}</span>
                          @if (item.hasInfo) {
                          <nh-popover
                            [iconMode]="'transparent'"
                            [content]="getInfoTooltip(item) | globalTranslate"
                            class="mobile-info-icon"
                          ></nh-popover>
                          }
                        </div>
                        <div class="mobile-card-amount">
                          <span class="dollar-sign-table" style="color: #ffffff"
                            >$</span
                          >
                          <span
                            >{{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}</span
                          >
                        </div>
                      </div>
                      <div class="mobile-card-body">
                        @for (row of item.tableData; track row; let isLast =
                        $last) {
                        <ng-container role="listitem">
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "PERSON" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value">
                              <div>{{ row.person }}</div>
                            </span>
                          </div>
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "TYPE" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value">{{
                              row.type
                            }}</span>
                          </div>
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{ row.amount | number: "1.2-2" }}</span
                            >
                          </div>
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "EXCLUDED_AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{ row.excludedAmount | number: "1.2-2" }}</span
                            >
                          </div>
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "COUNTABLE_AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{
                                row.countableAmount | number: "1.2-2"
                              }}</span
                            >
                          </div>
                          @if (!isLast) {
                          <hr class="mobile-card-divider" />
                          }
                        </ng-container>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
            }
          </div>
        </mat-expansion-panel>
      </div>
      }
    </mat-expansion-panel>
  </div>
  }

  <!-- Resources Section (All types if available) -->
  @if (resourceItems.length > 0) {
  <div>
    <mat-expansion-panel
      class="budget-section-panel"
      [(expanded)]="resourcesPanelExpanded"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          "RESOURCES_CALCULATION" | globalTranslate
        }}</mat-panel-title>
      </mat-expansion-panel-header>
      <h4 class="resources">{{ "COUNTABLE_RESOURCES" | globalTranslate }}</h4>
      <div
        class="budget-items-list"
        role="list"
        [attr.aria-label]="'COUNTABLE_RESOURCES' | globalTranslate"
      >
        @for (item of resourceItems; track item) {
        <div
          class="budget-item"
          role="listitem"
          [class.total-row]="item.isTotal"
          [class.result-row]="item.isResult"
        >
          <div
            class="budget-item-row"
            [class.hide-on-mobile-when-expanded]="isExpanded(item.id)"
          >
            @if (item.isExpandable) {
            <span
              class="expand-icon"
              (click)="toggleItem(item.id)"
              (keydown.enter)="toggleItem(item.id)"
              (keydown.space)="$event.preventDefault(); toggleItem(item.id)"
              tabindex="0"
              role="button"
              [attr.aria-expanded]="isExpanded(item.id)"
              [attr.aria-label]="item.label | globalTranslate"
            >
              @if (!isExpanded(item.id)) {
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M10 6 L10 14 M6 10 L14 10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              } @if (isExpanded(item.id)) {
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M6 10 L14 10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              }
            </span>
            }
            <div class="budget-label">
              @if (item?.isLink) {
              <span
                class="link-label"
                role="link"
                tabindex="0"
                [attr.aria-label]="
                  'View details for ' + (item.label | globalTranslate)
                "
                (click)="loadSubscreen(item)"
                (keydown.enter)="loadSubscreen(item)"
                (keydown.space)="$event.preventDefault(); loadSubscreen(item)"
              >
                {{ item.label | globalTranslate }}
              </span>
              } @else {
              <span>{{ item.label | globalTranslate }}</span>
              } @if (item?.hasInfo) {
              <nh-popover
                [content]="getInfoTooltip(item) | globalTranslate"
                class="info-icon-inline"
              ></nh-popover>
              }
            </div>
            <div class="budget-value">
              @if (item?.operator) {
              <span class="operator-sign">{{ item?.operator }}</span>
              } @if (!item.operator && item?.isCurrency !== false) {
              <span class="equals-sign">=</span>
              } @if (item?.isCurrency !== false) {
              <span class="dollar-sign">$</span>
              } @if (item?.isCurrency === false) {
              <span
                class="dollar-sign"
                style="visibility: hidden"
                aria-hidden="true"
                >$</span
              >
              }
              <span
                class="amount-value"
                [class.pass-result]="item?.amount === 'Pass'"
                >{{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}</span
              >
            </div>
          </div>
          <!-- Table Data for resources (when expanded) -->
          @if (isExpanded(item.id)) {
          <div class="detail-table-container" [@expandCollapse]>
            <!-- Desktop Table View -->
            <div
              class="budget-detail-table-wrapper d-none d-md-block"
              tabindex="0"
              role="region"
              [attr.aria-label]="
                (item.label | globalTranslate) + ' scrollable table ' + item.id
              "
            >
              <table
                class="budget-detail-table"
                role="table"
                [attr.aria-label]="
                  (item.label | globalTranslate) + ' details table'
                "
              >
                <thead role="rowgroup">
                  <tr role="row">
                    <th scope="col" role="columnheader">
                      {{ "RESOURCE_TYPE" | globalTranslate }}
                    </th>
                    @if (item?.resourceType === 'nonLiquid') {
                    <th scope="col" role="columnheader">
                      {{ "DESCRIPTION" | globalTranslate }}
                    </th>
                    } @if (item?.resourceType === 'liquid') {
                    <th scope="col" role="columnheader">
                      {{ "SPECIAL_CONSIDERATIONS" | globalTranslate }}
                    </th>
                    }
                    <th scope="col" role="columnheader">
                      {{ "VALUE" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "OWNER" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "PERCENT_OWNERSHIP" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "RES_EXCLUDED_AMOUNT" | globalTranslate }}
                    </th>
                    <th scope="col" role="columnheader">
                      {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                    </th>
                  </tr>
                </thead>
                <tbody
                  [@fadeInStagger]="item.tableData?.length || 0"
                  role="rowgroup"
                >
                  @for (row of item.tableData; track row) {
                  <tr role="row">
                    <td role="cell">{{ row.resourceType }}</td>
                    @if (item?.resourceType === 'nonLiquid') {
                    <td role="cell">{{ row.description }}</td>
                    } @if (item?.resourceType === 'liquid') {
                    <td role="cell">{{ row.specialConsiderations }}</td>
                    }
                    <td class="currency" role="cell">
                      ${{ row.value | number: "1.2-2" }}
                    </td>
                    <td role="cell">{{ row.owner }}</td>
                    <td role="cell">
                      {{ row.percentOwnership }}@if (row?.percentOwnership !==
                      'N/A') {
                      <span>%</span>
                      }
                    </td>
                    <td class="currency" role="cell">
                      ${{ row.excludedAmount | number: "1.2-2" }}
                    </td>
                    <td class="currency" role="cell">
                      ${{ row.countableAmount | number: "1.2-2" }}
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            <!-- Mobile Card View -->
            <div
              class="mobile-card-container d-md-none"
              role="list"
              [attr.aria-label]="
                (item.label | globalTranslate) + ' details list'
              "
            >
              <div class="mobile-card-wrapper">
                <span
                  class="mobile-card-icon mobile_icon"
                  (click)="toggleItem(item.id)"
                  (keydown.enter)="toggleItem(item.id)"
                  (keydown.space)="$event.preventDefault(); toggleItem(item.id)"
                  tabindex="0"
                  role="button"
                  [attr.aria-expanded]="isExpanded(item.id)"
                  [attr.aria-label]="item.label | globalTranslate"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="9"
                      stroke="currentColor"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M6 10 L14 10"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
                <div class="mobile-card">
                  <div class="mobile-card-header">
                    <div class="mobile-card-title">
                      <span>{{ item.label | globalTranslate }}</span>
                      @if (item.hasInfo) {
                      <nh-popover
                        [iconMode]="'transparent'"
                        [content]="getInfoTooltip(item) | globalTranslate"
                        class="mobile-info-icon"
                      ></nh-popover>
                      }
                    </div>
                    <div class="mobile-card-amount">
                      <span class="dollar-sign-table" style="color: #ffffff"
                        >$</span
                      >
                      <span
                        >{{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}</span
                      >
                    </div>
                  </div>
                  <div class="mobile-card-body">
                    @for (row of item.tableData; track row; let isLast = $last)
                    {
                    <ng-container role="listitem">
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "RESOURCE_TYPE" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">{{
                          row.resourceType
                        }}</span>
                      </div>
                      @if (item?.resourceType === 'nonLiquid') {
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "DESCRIPTION" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">{{
                          row.description
                        }}</span>
                      </div>
                      } @if (item?.resourceType === 'liquid') {
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "SPECIAL_CONSIDERATIONS" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">{{
                          row.specialConsiderations
                        }}</span>
                      </div>
                      }
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "VALUE" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">${{ row.value }}</span>
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "OWNER" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value">{{ row.owner }}</span>
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "PERCENT_OWNERSHIP" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value"
                          >{{ row.percentOwnership }}@if (row?.percentOwnership
                          !== 'N/A') {
                          <span>%</span>
                          }</span
                        >
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "RES_EXCLUDED_AMOUNT" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value"
                          >${{ row.excludedAmount | number: "1.2-2" }}</span
                        >
                      </div>
                      <div class="mobile-card-row">
                        <span class="mobile-card-label">{{
                          "COUNTABLE_AMOUNT" | globalTranslate
                        }}</span>
                        <span class="mobile-card-value"
                          >${{ row.countableAmount | number: "1.2-2" }}</span
                        >
                      </div>
                      @if (!isLast) {
                      <hr class="mobile-card-divider" />
                      }
                    </ng-container>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
    </mat-expansion-panel>
  </div>
  }
</div>